import React, { useCallback } from 'react';
import { prop } from 'ramda';
import { Button } from 'js/components/common/Button';
import { useFormatter } from 'js/hooks/useFormatter';
import { useUserSelector } from 'js/store/hooks';

import style from './SuggestionItem.scss';

export const SuggestionItem = ({ suggestion, onClick }) => {
    const formatter = useFormatter();
    const currencyCode = useUserSelector(prop(['currencyCode']));

    const onClickHandler = useCallback(
        e => onClick(e.currentTarget.value),
        [onClick]
    );

    return (
        <li className={style.item}>
            <Button
                className={style.btn}
                onClick={onClickHandler}
                value={suggestion}
                view="secondary"
                variant="rounded"
                color="info"
                size="small"
            >
                {formatter.formatCurrency(suggestion, { currencyCode })}
            </Button>
        </li>
    );
};
